<template>
  <footer
    :style="`background-color: ${backgroundColor};text-align: ${textAlign};height: 30px; z-index: 10;`"
    class="px-0 py-2 footer w-100 font-weight-normal bottom-0 left-0"
  >
    <b-row
      class="justify-content-center align-items-center position-relative w-100"
    >
      <b-col lg="6" v-show="0">
        <div class="copyright">
          © {{ year }},
          <a class="font-weight-bold ml-1"
            >Janoo® - Sistema de Gestão de Atrações Turísticas todos os direitos
            reservados</a
          >
        </div>
      </b-col>

      <a
        style="font-weight: small !important; font-size: 0.7rem"
        href="//janoo.com.br/gestaoturismo"
        target="_blank"
      >
        Janoo® - v{{ bcVersion }}
      </a>
    </b-row>
  </footer>
</template>
<script>
import { startReleaseWatch } from '@/services/releaseCheck'

export default {
  props: {
    backgroundColor: {
      type: String,
      default: 'white',
    },
    position: {
      type: String,
      default: 'fixed',
    },
    textAlign: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {
      bcVersion: process.env.VUE_APP_VERSION,
      year: new Date().getFullYear(),
    }
  },
  created() {
    startReleaseWatch()
    console.log(
      'sistema.janoo.com.br® version: ',
      this.bcVersion
    )
  },
}
</script>
